import React from "react";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Header from "../../components/Header";
import AppBar from "@mui/material/AppBar";
import Footer from "../../components/Footer";
import Banner from "./components/Banner";
import ServiceList from "./components/ServiceList";
import Caption from "./components/Caption";
// import Image from "../../images/wireframe.jpg";
import OurTeam from "./components/OurTeam";
import Scroll from "../Header/Scroll";
import Whatsapp from "../Footer/Whatsapp";
import Image2 from "../../images/bg1.png";
import Approach from "./components/Approach";

// const styles = {
//   paperContainer: {
//     height: 800,
//     backgroundImage: `url(${Image})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//   },
// };

const styles2 = {
  paperContainer: {
    height: 550,
    backgroundImage: `url(${Image2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Services = () => {
  return (
    <Box>
      <Scroll>
        <AppBar
          position={"fixed"}
          elevation={0}
          sx={{
            padding: "10px 0px",
          }}
        >
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box bgcolor={"#000"}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box>
        <Container>
          <OurTeam />
        </Container>
      </Box>
      <Box bgcolor={"#000"}>
        <Container>
          <ServiceList />
        </Container>
      </Box>
      <Box>
        <Container>
          <Approach />
        </Container>
      </Box>
      <Box>
        <Container style={styles2.paperContainer}>
          <Caption />
        </Container>
      </Box>
      <Box bgcolor={"#000"}>
        <Container>
          <Footer />
        </Container>
      </Box>
      <Whatsapp />
    </Box>
  );
};

export default Services;
